<template>
  <div class="kb-main">
    <div class="h-full">
      <div v-if="localKanbanCols && localKanbanCols.length" class="h-full">
        <div :list="localKanbanCols" group="kb-col" :move="checkColMove" class="vx-row pb-4 bg-main h-full"
          style="overflow-x: auto; overflow-y: hidden; flex-wrap: nowrap" :scroll-sensitivity="200"
          :force-fallback="true">
          <div v-for="(col, index) in localKanbanCols" :key="index" class="vx-col">
            <div class="kb-col-head flex items-center justify-between mb-2 bg-white"
              :class="index === editingIndex ? 'py-2 pl-4' : ''">
              <div>
                <h4 v-if="index !== editingIndex" class="">
                  {{ col.title }}
                </h4>

                <vs-input v-else class="" v-model="tempColTitle" @blur="updateKanbanColTitle(editingIndex)"
                  @keyup.enter="updateKanbanColTitle(editingIndex)" :autofocus="true" size="large" />
              </div>

              <!-- <feather-icon icon="MoreVerticalIcon" class="cursor-pointer" svgClasses="w-5 h-5" /> -->
              <div class="flex">
                <div>
                  <vx-tooltip text="Edit" position="bottom">
                    <feather-icon icon="Edit2Icon" svgClasses="w-5 h-5 cursor-pointer stroke-current text-primary"
                      @click.stop="editCol(col, index)" />
                  </vx-tooltip>
                </div>
                <div v-if="index !== 0">
                  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                    <a class="a-icon cursor-pointer text-dark ml-1" href="#">
                      <feather-icon icon="MoreVerticalIcon" class="cursor-pointer" svgClasses="w-5 h-5" />
                    </a>
                    <vs-dropdown-menu>
                      <vs-dropdown-item
                        @click.stop="userCardView === 'minimized' &&
                          !userCardViewMaxColIndex.includes(index) ? userCardViewMaxColIndex.push(index) : removeUserCardViewMaxColIndex(index)">
                        <div v-if="
                          userCardView === 'minimized' &&
                          !userCardViewMaxColIndex.includes(index)
                        " style="display: flex; align-items: baseline" class="items-center">
                          Classic View
                        </div>
                        <div v-else style="display: flex; align-items: baseline" class="items-center">
                          Compact View
                        </div>
                      </vs-dropdown-item>
                      <vs-dropdown-item style="min-width: 11rem; font-size: 14.5px">
                        <vx-tooltip v-if="!(localKanbanCols[index].colUsersData &&
                          localKanbanCols[index].colUsersData.length === 0)" text="Only empty columns can be deleted"
                          position="bottom">
                          <div>
                            Delete Column
                          </div>
                        </vx-tooltip>
                        <div v-else>
                          Delete Column
                        </div>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </div>

            <div v-if="col.description || index === editingIndex" class="org-card kb-col break-all ">

              <p v-if="index !== editingIndex" class="text-grey-600">
                <span class="text-lg text-grey-800">Description:</span> {{ col.description }}
              </p>

              <vs-input v-else class="w-full mb-5 mt-1" v-model="tempColDesc" placeholder="Enter description"
                @blur="updateKanbanColDesc(editingIndex)" @keyup.enter="updateKanbanColDesc(editingIndex)"
                :autofocus="true" size="large" />
            </div>

            <div class="org-card kb-col bg-col scrollbarWidth mt-6 h-full" style="overflow-x: hidden; overflow-y: auto">

              <draggable :list="col.colUsersData" :data-colid="col._id"
                :data-col="col.title.split(' ').join('___________')" group="kb-col-items" style="height: 150px"
                :move="userCardMoved">
                <div v-for="(i2, ix2) in col.colUsersData" :key="ix2"
                  class="kanban-user-card cursor-pointer kb-col-item p-2 mb-3" :style="[
                    profileCompletionMap[i2.boardUserId]
                      ? {
                        borderBottom: '2px solid transparent',
                        borderImage: `linear-gradient(to right, rgba(var(--vs-primary)) ${profileCompletionMap[i2.boardUserId].profilePercent
                          }%, transparent ${profileCompletionMap[i2.boardUserId].profilePercent
                          }%) 100% 1`,
                      }
                      : {},
                  ]">
                  <div v-if="i2.boardUserId && getBoardUserData(i2.boardUserId)">
                    <user-card :boardUserData="getBoardUserData(i2.boardUserId)" :userCardView="userCardViewMaxColIndex.includes(index)
                      ? 'maximized'
                      : 'minimized'
                      " :kanbanId="kanbanData._id" :kanbanColId="col._id" @assignCoach="assignCoach" />
                  </div>
                </div>
                <div style="height: 100px;"></div>
              </draggable>
            </div>
          </div>
          <div class="vx-col" draggable="false">
            <div
              class="px-8 py-32 border-dashed border-2 border-slate-300 h-fit bg-slate-200 relative flex justify-center items-center rounded-lg cursor-pointer"
              v-if="!showInputforAddColumn" @click.stop="showInputforAddColumn = true">
              <p
                class="absolute flex flex-row items-center justify-center gap-4 rotate-90 transform text-2xl whitespace-no-wrap text-slate-800">
                <span class="w-6 h-6 flex justify-start items-start">
                  <svg class="w-full h-full object-cover" width="21" height="21" viewBox="0 0 21 21" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.5 10.5L10.5 10.5L7.5 10.5ZM10.5 10.5L13.5 10.5L10.5 10.5ZM10.5 10.5L10.5 7.5L10.5 10.5ZM10.5 10.5L10.5 13.5L10.5 10.5ZM10.5 1.5C11.6819 1.5 12.8522 1.73279 13.9442 2.18508C15.0361 2.63738 16.0282 3.30031 16.864 4.13604C17.6997 4.97177 18.3626 5.96392 18.8149 7.05585C19.2672 8.14778 19.5 9.3181 19.5 10.5C19.5 11.6819 19.2672 12.8522 18.8149 13.9442C18.3626 15.0361 17.6997 16.0282 16.864 16.864C16.0282 17.6997 15.0361 18.3626 13.9442 18.8149C12.8522 19.2672 11.6819 19.5 10.5 19.5C8.11305 19.5 5.82387 18.5518 4.13604 16.864C2.44821 15.1761 1.5 12.8869 1.5 10.5C1.5 8.11305 2.44821 5.82387 4.13604 4.13604C5.82387 2.44821 8.11305 1.5 10.5 1.5Z"
                      stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </span>
                Add Column
              </p>
            </div>
            <div class="cursor-pointer p-3">
              <h3 v-if="!showInputforAddColumn" @click.stop="showInputforAddColumn = true" class="items-center hidden">
                + Add a Column
              </h3>
              <div v-else>
                <vs-input class="add-col w-full mb-3" v-model="newColumnTitle" placeholder="Add a column"
                  size="large" />
                <vs-button @click.stop="
                  addColumn();
                updateKanban();
                " style="border-radius: 6px">Add</vs-button>
                <vs-button @click.stop="showInputforAddColumn = false"
                  style="border-radius: 6px; background-color: white !important; color: black; box-shadow: none;"
                  class="ml-4">
                  Cancel</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import _ from "lodash";
import constants from "@/constants.js";
import UserCard from "./UserCard.vue";
import KanbanSkeleton from "./components/Kanban.skeleton.vue";

export default {
  props: {
    // currentBoardUsers: {
    //     type: Array,
    //     required: true
    // },
    isAlexInstalled: {
      type: Boolean,
    },
  },
  data() {
    return {
      editingIndex: -1,
      userCardViewMaxColIndex: [],
      localKanbanCols: [],
      newColumnTitle: "",
      isAddColumn: false,
      showInputforAddColumn: false,
      constants,
      userCardView: "minimized",
      tempColTitle: "",
      tempColDesc: "",
    };
  },
  components: {
    draggable,
    UserCard,
    KanbanSkeleton,
  },
  computed: {
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
    kanbanData() {
      return this.$store.state.kanban.kanbanData;
    },
    currentBoardUsers() {
      return this.$store.state.boards.currentBoardUsers;
    },
    userData() {
      return this.$store.state.users.data;
    },
    profileCompletionMap() {
      return this.$store.state.boards.profileCompletionMap;
    },
  },
  watch: {
    currentBoard(newVal) {
      if (newVal) {
        this.fetchKanbanData();

        // fetch BoardUserProfileAnalytics
        this.$store.dispatch(
          "boards/fetchBoardUserProfileAnalytics",
          newVal._id
        );
      }
    },
    currentBoardUsers(newVal) {
      if (newVal) {
        this.fetchKanbanData();
      }
    },
    kanbanData(newVal) {
      if (newVal) {
        this.localKanbanCols = JSON.parse(JSON.stringify(newVal.cols));
        this.$forceUpdate();
      }
    },
    localKanbanCols: {
      deep: true,
      handler(newVal) {
        if (newVal && this.kanbanData._id) {
          if (!_.isEqual(newVal, this.kanbanData.cols)) {
            _.debounce(this.updateKanban, 500)();
          }
        }
      },
    },
    profileCompletionMap: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
  methods: {
    checkColMove(evt) {
      this.editingIndex = -1;
      if (
        !evt.draggedContext.element ||
        !evt.draggedContext.element._id ||
        !evt.relatedContext.element
      ) {
        return false;
      } else if (
        !evt.draggedContext.element ||
        evt.draggedContext.element.title === "Initial Phase"
      ) {
        return false;
      } else if (
        evt.draggedContext.index === 0 ||
        evt.relatedContext.index === 0
      ) {
        return false;
      }
      return true;
    },
    getBoardUserData(boardUserId) {
      return _.find(this.currentBoardUsers, (cbu) => {
        return cbu._id === boardUserId;
      });
    },
    addColumn() {
      this.localKanbanCols.push({
        title: this.newColumnTitle || "Column Name",
        colUsersData: [],
      });
      this.isAddColumn = true;
      this.showInputforAddColumn = false;
      this.newColumnTitle = "";
    },
    fetchKanbanData() {
      this.$store.dispatch("kanban/getKanbanDataV2", this.currentBoard._id);
    },
    updateKanbanColTitle(index) {
      if (index !== -1) {
        this.localKanbanCols[index].title = this.tempColTitle;
        this.tempColTitle = "";
        this.editingIndex = -1;
        this.updateKanban();
      }
    },
    updateKanbanColDesc(index) {
      if (index !== -1) {
        this.localKanbanCols[index].description = this.tempColDesc;
        this.tempColDesc = "";
        this.editingIndex = -1;
        this.updateKanban();
      }
    },
    updateKanban() {
      this.$store
        .dispatch("kanban/updateKanbanV2", {
          boardId: this.kanbanData.boardId,
          cols: this.localKanbanCols,
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteColumn(index) {
      this.localKanbanCols.splice(index, 1);
    },
    removeUserCardViewMaxColIndex(index) {
      const i = this.userCardViewMaxColIndex.findIndex((indx) => {
        return indx === index;
      });
      this.userCardViewMaxColIndex.splice(i, 1);
    },
    userCardMoved(uc) {
      const fromCol = uc.from
        .getAttribute("data-col")
        .split("___________")
        .join(" ");
      const toCol = uc.to
        .getAttribute("data-col")
        .split("___________")
        .join(" ");
      const boardUserData = this.getBoardUserData(
        uc.draggedContext.element.boardUserId
      );
      const boardUserName = `${boardUserData.userData.firstName} ${boardUserData.userData.lastName}`;
      if (boardUserData) {
        const fromColId = uc.from.getAttribute("data-colid");
        const toColId = uc.to.getAttribute("data-colid")
        if (fromColId !== toColId) {
          this.$store.dispatch("organization/logOrganizationActivity", {
            organizationId: this.currentBoard.organizationId,
            logObj: {
              logText: `Moved ${boardUserName} from ${fromCol} to ${toCol} on ${this.currentBoard.title} Board`,
              status: "active",
              boardId: this.currentBoard._id,
              boardUserId: boardUserData._id,
              userId: this.userData._id,
            },
          });
          const userStepPayload = {
            boardId: this.currentBoard._id,
            kanbanColId: this.localKanbanCols.filter(c => c.title == toCol).map((c) => c._id)[0],
            userId: boardUserData.userId,
            reviewStatus: 'PENDING'
          }
          const fromColIndex = this.localKanbanCols.map(c => c._id).indexOf(fromColId);
          const toColIndex = this.localKanbanCols.map(c => c._id).indexOf(toColId);
          if (fromColIndex > toColIndex) {
            userStepPayload.kanbanColId = fromColId;
            userStepPayload.reviewStatus = 'PENDING';
            this.$store.dispatch("boards/updateBoardStep", userStepPayload)
              .then(res => {
                if (res.status == 'SUCCESS') {
                  console.log("your from updated data", res.data);
                  userStepPayload.kanbanColId = toColId;
                  userStepPayload.reviewStatus = "USER_ACCEPTED";
                  this.$store.dispatch("boards/updateBoardStep", userStepPayload)
                    .then(res => {
                      console.log("your to updated data", res.data);
                    })
                }
              })
          }
          else {
            userStepPayload.kanbanColId = fromColId;
            userStepPayload.reviewStatus = "USER_ACCEPTED";
            this.$store.dispatch("boards/updateBoardStep", userStepPayload)
              .then(res => {
                if (res.status == 'SUCCESS') {
                  userStepPayload.kanbanColId = toColId;
                  userStepPayload.reviewStatus = "USER_ACCEPTED";
                  this.$store.dispatch("boards/updateBoardStep", userStepPayload)
                    .then(res => {
                      console.log("your to updated data", res.data);
                    })
                }
              })
          }
        }
      }
    },
    assignCoach(traineeId) {
      this.$emit("assignCoach", traineeId);
    },
    editCol(col, index) {
      if (this.editingIndex !== index) {
        this.editingIndex = index;
        this.tempColTitle = col.title;
        this.tempColDesc = col.description;
      } else {
        this.editingIndex = -1;
      }
    },
  },
  created() {
    if (this.currentBoard && this.currentBoard._id) {
      this.fetchKanbanData();

      // fetch BoardUserProfileAnalytics
      this.$store.dispatch(
        "boards/fetchBoardUserProfileAnalytics",
        this.currentBoard._id
      );
    }
  },
};
</script>

<style scoped lang="scss">
.kb-col-head {
  border-bottom: 3px solid rgba(var(--vs-primary), 1);
}
</style>

<style scoped>
.kb-main {
  height: calc(100vh - 13.6rem);
  border-radius: 8px;
}

.bg-main {
  background-color: transparent !important;
}

.kanban-user-card {
  /* background: #F4F6FB; */
  background: #ffffff;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
}

.vx-col:nth-child(1) .bg-col .kanban-user-card {
  /*background: rgba(223, 227, 235, 0.5);*/
  background: #ffffff;
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
}

.vx-col:nth-child(1) .bg-col {
  /*background: rgba(223, 227, 235, 0.5);*/
  /* background-color: #ECECED; */
  background-color: transparent;
}

.bg-col {
  /* background: rgba(223, 227, 235, 1); */
  background: transparent;
  border-radius: 4px;
}

.org-card.kb-col {
  width: 320px !important;
  box-shadow: none;
}

.add-col {
  width: 320px !important;
  height: fit-content !important;
  border: 1px dashed #b2bac8;
  border-radius: 8px;
}

/* .kb-col-item {
  /* box-shadow: none!important; 
} */

.org-card.kb-col.vx-card>.vx-card__collapsible-content .vx-card__body {
  padding: 0 0 1.5rem 0 !important;
}

.kb-col-head {
  padding: 1.5rem;
  background: #dfe3eb;
  border-radius: 4px;
}

.scrollbarWidth::-webkit-scrollbar {
  width: 10px;
}

.scrollbarWidth::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(41, 39, 39, 0.3);
  border-radius: 10px;
}

.scrollbarWidth::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 20px rgb(193 193 193);
}
</style>
